// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1tsYF","placeholdersHeader":"styles_placeholdersHeader__now7V","editorStyle":"styles_editorStyle__3QTNQ","placeholdersBox":"styles_placeholdersBox__AfLee"};